import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/close_bai.png'
import _imports_1 from '@/assets/offers/deposit_promotions_iconmsg.png'


const _hoisted_1 = { class: "pop_container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "btn_container" }

import MainButton from '../../components/common/mainButton.vue'
import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'infoPoup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const title = ref('')
const open = (data: string) => {
    title.value = `offers.${data}`
    show.value = true
}
const close = () => {
    show.value = false
}
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    style: {
        minWidth: '100%',
        minHeight: '60%',
        background: 'transparent',
        borderRadius: '10px',
        color: '#95a9d3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "close_icon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: close
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bell_icon" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('offers.promotionContent')) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(title.value)), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(MainButton, {
            title: _ctx.$t('common.ok'),
            onclick: close,
            activeStatus: true
          }, null, 8, ["title"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})